import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-5.webp";
import diverseImage from "../images/comp/choose_cms_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import ux_icon from "../images/ux_icon.png";
import supportIcon from "../images/Support.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import testingIcon from "../images/Testing.png";
const CrmdevelopmentPage = () => {
  const heroBannerData = {
    subtitle: "CRM Development",
    title: "CRMs That Engage. CRMs That Empower.",
    description:
      "At Hope Web Solutions, we build high-performing, scalable CRMs tailored to your business goals. Whether you're launching a startup or modernizing an enterprise platform, our expert developers create fast, secure, and user-friendly CRMs that drive results. We focus on clean code, responsive design, and seamless user experience across all devices.",
    buttonText: "Contact now",
    buttonLink: "#contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Custom CRM Development",
      description:
        "Building CRM systems from scratch to match your unique sales, marketing, and customer service workflows.",
      icon: researchIcon,
    },
    {
      title: "CRM Integration Services",
      description:
        "Seamlessly integrating CRM systems with your existing business applications and data sources to enhance workflow efficiency.",
      icon: planningIcon,
    },
    {
      title: "Cloud-Based CRM Solutions",
      description:
        "Deploying CRMs in the cloud for scalability, accessibility, and cost-effective maintenance without the need for on-premise infrastructure.",
      icon: designIcon,
    },
    {
      title: "CRM Dashboard & Reporting",
      description:
        "Creating user-friendly dashboards and reports to provide real-time insights into sales, marketing, and customer interactions for better decision-making.",
      icon: developmentIcon,
    },
    {
      title: "Workflow & Automation",
      description:
        "Automating repetitive tasks like follow-ups, lead nurturing, and customer segmentation to boost efficiency.",
      icon: testingIcon,
    },
    {
      title: "User Access & Role Management",
      description:
        "Secure login systems with different permission levels for admins, agents, and other roles.",
      icon: qualityIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Identifying your current process gaps, goals, and CRM functionalities required.",
      icon: researchIcon,
    },
    {
      title: "Planning & Strategy",
      description:
        "Defining modules, user roles, and workflows tailored to your sales and support teams.",
      icon: designIcon,
    },
    {
      title: "UI/UX Design",
      description:
        "Designing intuitive dashboards and reports with clear data visualization for actionable insights.",
      icon: ux_icon,
    },
    {
      title: "Development & Integration",
      description:
        "Building the CRM system with secure data handling, API integrations, and real-time data synchronization.",
      icon: developmentIcon,
    },
    {
      title: "Testing & Feedback",
      description:
        "Conducting rigorous testing and gathering user feedback for a smooth, bug-free launch.",
      icon: testingIcon,
    },
    {
      title: "Deployment & Support",
      description:
        "Launching the CRM system and providing ongoing support, upgrades, and user training.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">CRM Development Services</h2>
              <p className="sub-title text-black pt-2">
                We offer full-cycle CRM development services to streamline your
                business operations and improve customer engagement.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="CRM Development Process"
        subtitle="Our structured development process ensures high-quality, secure, and scalable CRM solutions delivered on time."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default CrmdevelopmentPage;
